import { render, staticRenderFns } from "./OrganisationMigrationWindowView.vue?vue&type=template&id=0883d480&scoped=true&"
import script from "./OrganisationMigrationWindowView.vue?vue&type=script&lang=js&"
export * from "./OrganisationMigrationWindowView.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationMigrationWindowView.vue?vue&type=style&index=0&id=0883d480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883d480",
  null
  
)

export default component.exports